import {
  SET_ALERTS_FILTER_DATA,
  SET_ALERTS_LIMIT_PAGE,
  SET_ALERTS_PAGE_NUMBER,
  SET_ALERT_RULE_CONDITIONS,
  SET_ALERT_RULE_LIMIT_PAGE,
  SET_ALERT_RULE_PAGE_NUMBER,
  SET_ALERT_RULE_STATUSES,
  SET_ALERT_RULE_STORES
} from './actions'
import { initialState } from './selectors'

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ALERTS_PAGE_NUMBER:
      return {
        ...state,
        alertsPageNumber: payload
      }
    case SET_ALERTS_LIMIT_PAGE:
      return {
        ...state,
        alertsLimitPage: payload
      }
    case SET_ALERTS_FILTER_DATA:
      return {
        ...state,
        filterData: payload
      }
    case SET_ALERT_RULE_CONDITIONS:
      return {
        ...state,
        alertRuleConditions: payload
      }

    case SET_ALERT_RULE_STATUSES:
      return {
        ...state,
        alertRuleStatuses: payload
      }
    case SET_ALERT_RULE_STORES:
      return {
        ...state,
        alertRuleStores: payload
      }
    case SET_ALERT_RULE_LIMIT_PAGE:
      return {
        ...state,
        alertRuleLimitPage: payload
      }
    case SET_ALERT_RULE_PAGE_NUMBER:
      return {
        ...state,
        alertRulePageNumber: payload
      }
    default:
      return state
  }
}
